import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { HomePage } from '../home/home.page';
import { MenuPage } from '../menu/menu.page';
import { RepositoryService } from '../../../smoothr-web-app-core/services/repository/repository.service';
import { environment } from '../../../environments/environment';
import { NavigationService } from 'src/app/services/navigation.service';
import { Location } from '@angular/common';
import { Api } from '../../../smoothr-web-app-core/api/api';
import { Legal } from '../../../smoothr-web-app-core/models/Legal';
import { LoadingController } from '@ionic/angular';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
	selector: 'app-impressum',
	templateUrl: './impressum.page.html',
	styleUrls: ['impressum.page.scss'],
})
export class ImpressumPage {
	static url = 'impressum';
	environment = environment;
	legalContent: SafeHtml | null = null;
	isLoading = false;
	useDynamicContent = false;

	constructor(
		private repository: RepositoryService,
		private navigationService: NavigationService,
		private location: Location,
		private loadingController: LoadingController,
		private sanitizer: DomSanitizer
	) {
		this.loadDynamicContent();
	}

	async loadDynamicContent() {
		if (!this.repository._venue?._id) {
			return;
		}

		this.isLoading = true;
		const loading = await this.loadingController.create({
			message: 'Loading...',
		});
		await loading.present();

		try {
			const response = await Api.getLegal(this.repository._venue._id);
			const legal: Legal = response.data;

			if (legal.type === 'html' && legal.imprint) {
				this.legalContent = this.sanitizer.bypassSecurityTrustHtml(legal.imprint);
				this.useDynamicContent = true;
			} else if (legal.type === 'pdf' && legal.imprint) {
				window.open(legal.imprint, '_blank');
			}
		} catch (error) {
			console.error('Error loading Impressum:', error);
			this.useDynamicContent = false;
		} finally {
			this.isLoading = false;
			await loading.dismiss();
		}
	}

	async goBack() {
		if (this.location) {
			this.location.back();
			return;
		}
		if (this.repository._order === null) {
			await this.navigationService.home();
		} else {
			await this.navigationService.menu();
		}
	}
}
